(() => {
  const groups = {
    15427707699506: 'apparel',
    15427716841778: 'apparel',
    15427744891186: 'apparel',
    15427748921650: 'apparel',
    15427752427826: 'apparel',
    15427720675634: 'apparel',
    15427724607794: 'apparel',
    15427755737394: 'apparel',
    15427778249010: 'apparel',
    15427780608306: 'sock',
    15427780706610: 'sock',
    15431250182450: 'sock',
    15427780935986: 'sock',
    15427781034290: 'sock',
    15427781132594: 'sock'
  };
  let currentCart = null;
  let eventCartValid = false;
  let checkoutBypass = false;
  let checkingCheckout = false;
  const discountCheckoutUrl = '/discount/AM26?redirect=%2Fcheckout';

  const category = (productId) => groups[String(productId)] || null;
  const cartUrl = () => `${(window.routes && window.routes.cart_url) || '/cart'}.js`;

  async function loadCart() {
    const response = await fetch(cartUrl(), { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Could not check your gift selections. Please try again.');
    currentCart = await response.json();
    return currentCart;
  }

  function countSelections(cart) {
    const counts = { apparel: 0, sock: 0 };
    let eventItems = 0;
    for (const item of cart.items) {
      const group = category(item.product_id);
      if (group) {
        counts[group] += item.quantity;
        eventItems += item.quantity;
      }
    }
    return { counts, eventItems };
  }

  function status(message, valid) {
    for (const button of document.querySelectorAll('#checkout, #CartDrawer-Checkout')) {
      button.disabled = !valid;
      let note = button.parentElement.querySelector('.amm-gift-status');
      if (!note) {
        note = document.createElement('p');
        note.className = 'amm-gift-status';
        note.setAttribute('role', 'status');
        button.insertAdjacentElement('afterend', note);
      }
      note.textContent = message;
    }
  }

  function render(cart) {
    const { counts, eventItems } = countSelections(cart);
    for (const input of document.querySelectorAll('.quantity__input[data-amm-product-id]')) {
      const group = category(input.dataset.ammProductId);
      if (group === 'sock') input.max = '1';
      if (group === 'apparel') {
        const lineQuantity = Number(input.value) || 1;
        input.max = String(Math.max(1, 2 - (counts.apparel - lineQuantity)));
      }
    }
    if (!eventItems) {
      eventCartValid = false;
      for (const button of document.querySelectorAll('#checkout, #CartDrawer-Checkout')) {
        button.disabled = cart.items.length === 0;
        if (button.dataset.ammOriginalText) button.textContent = button.dataset.ammOriginalText;
      }
      document.querySelectorAll('.amm-gift-status').forEach((note) => note.remove());
      document.querySelectorAll('.additional-checkout-buttons').forEach((buttons) => { buttons.hidden = false; });
      return;
    }

    eventCartValid = cart.items.reduce((total, item) => total + item.quantity, 0) === 3 &&
      counts.apparel === 2 && counts.sock === 1 &&
      cart.items.every((item) => Boolean(category(item.product_id)));
    const message = eventCartValid
      ? 'Your two apparel pieces and socks are ready. We’ll apply AM26 when you continue. Use the email on your invitation and confirm the total is $0.'
      : `${counts.apparel}/2 apparel pieces · ${counts.sock}/1 pair of socks. Choose any two apparel pieces and one pair of socks, then remove any extra items before checkout.`;
    status(message, eventCartValid);
    for (const button of document.querySelectorAll('#checkout, #CartDrawer-Checkout')) {
      if (!button.dataset.ammOriginalText) button.dataset.ammOriginalText = button.textContent;
      button.textContent = 'Continue with my gift';
    }
    for (const buttons of document.querySelectorAll('.additional-checkout-buttons')) {
      buttons.hidden = true;
    }
  }

  async function refresh() {
    try {
      render(await loadCart());
    } catch (error) {
      eventCartValid = false;
      status('We could not check your gift selections. Please refresh and try again.', false);
    }
  }

  window.AMMGiftGuard = {
    isEventProduct: (productId) => Boolean(category(productId)),
    showMessage: (message) => status(message, false),
    refresh,
    async canAdd(productId, quantity) {
      const group = category(productId);
      const amount = Number(quantity);
      if (group && (!Number.isInteger(amount) || amount < 1 || amount > (group === 'apparel' ? 2 : 1))) {
        return { ok: false, message: group === 'apparel' ? 'Choose up to two of this apparel item.' : 'Choose one pair of socks.' };
      }
      try {
        const cart = await loadCart();
        const { counts, eventItems } = countSelections(cart);
        if (!group) {
          return eventItems
            ? { ok: false, message: 'This gift bag can contain only two apparel pieces and one pair of socks.' }
            : { ok: true };
        }
        if (cart.items.some((item) => !category(item.product_id))) {
          return { ok: false, message: 'Please remove other items before building your event gift.' };
        }
        if (group === 'apparel' && counts.apparel + amount > 2) {
          return { ok: false, message: 'You already have two apparel pieces. Remove one from your bag before choosing another.' };
        }
        if (group === 'sock' && counts.sock + amount > 1) {
          return { ok: false, message: 'You already chose your socks. Remove that pair to switch styles.' };
        }
        if (eventItems + amount > 3) {
          return { ok: false, message: 'Your gift includes two apparel pieces and one pair of socks.' };
        }
        return { ok: true };
      } catch (error) {
        return { ok: false, message: error.message };
      }
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    refresh();
    window.addEventListener('pageshow', refresh);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(refresh, 100));
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const button = event.submitter;
    if (!['cart', 'CartDrawer-Form'].includes(form?.id) || button?.name !== 'checkout') return;
    if (checkoutBypass) { checkoutBypass = false; return; }
    event.preventDefault();
    if (checkingCheckout) return;
    checkingCheckout = true;
    try {
      const cart = await loadCart();
      render(cart);
      if (eventCartValid) {
        window.location.assign(discountCheckoutUrl);
      } else if (!countSelections(cart).eventItems) {
        checkoutBypass = true;
        form.requestSubmit(button);
      } else {
        status('Choose any two apparel pieces and one pair of socks before checkout.', false);
      }
    } catch (error) {
      status('We could not check your gift selections. Please refresh and try again.', false);
    } finally {
      checkingCheckout = false;
    }
  }, true);

  document.addEventListener('change', (event) => {
    const input = event.target.closest('.quantity__input[data-amm-product-id]');
    if (!input) return;
    const group = category(input.dataset.ammProductId);
    if (!group) return;
    const limit = Number(input.max) || (group === 'apparel' ? 2 : 1);
    if (Number(input.value) > limit) {
      input.value = String(limit);
      status(group === 'sock'
        ? 'Choose one pair of socks.'
        : 'Your gift includes two apparel pieces. Remove another piece before increasing this quantity.', false);
    }
  }, true);
})();